export default __webpack_public_path__ + "static/header.bioheizwerk.uebersicht-babfe1c6527d41f90d68c22db01cfb8d.png";